import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min.js'; // استيراد JavaScript
import HeaderTop from './components/HeaderTop/HeaderTop';
import NavBar from './components/NavBar/NavBar';
import Banner from './components/Banner/Banner';
import Service from './components/Service/Service';
import Box from './components/Box/Box';
import About from './components/About/About';
import Work from './components/Work/Work';
import OpaenTime from './components/OpaenTime/OpaenTime';
import Faq from './components/Faq/Faq';
import Footer from './components/Footer/Footer';
import { BiSolidPhoneCall } from "react-icons/bi";



function App() {
  return (
    <div className="App" style={{ backgroundColor: 'var(--main-bg-color)', color: 'var(--main-text-color)' }}>
      <HeaderTop />
      <NavBar />
      <Banner />
      <Service />
      <Box />
      <About />
      <Work />
      <Faq />
      <OpaenTime />
      <Footer />
      <a href="tel:0552092011" className="whatsapp-float"  rel="noopener noreferrer">
        <BiSolidPhoneCall  size={40} />
      </a>
    </div>
  );
}

export default App;
